import type {DataValue, VerifiedLinkedCatalogPost} from '../types';
import {isVerifiedLinkedCollectionLink} from './isVerifiedLinkedCollectionLink';

export const isVerifiedLinkedCollection = (
  link: DataValue | undefined,
): link is VerifiedLinkedCatalogPost =>
  isVerifiedLinkedCollectionLink((link as VerifiedLinkedCatalogPost).link);
